import { render, staticRenderFns } from "./EntryClosed.vue?vue&type=template&id=c74e821e&"
import script from "./EntryClosed.vue?vue&type=script&lang=js&"
export * from "./EntryClosed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports